import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: "app-dispute-report-search",
  templateUrl: "./dispute-report-search.component.html",
  styleUrls: ["./dispute-report-search.component.css"]
})
export class DisputeReportSearchComponent implements OnInit {
  @Input() title: string;
  @Output() close: EventEmitter<void> = new EventEmitter();
  @Output() filterChange: EventEmitter<any> = new EventEmitter();
  form: FormGroup;
  groups = [];
  by = [];
  types = [];

  constructor(private fb: FormBuilder) {
    this.buildForm();
  }

  ngOnInit() {}

  buildForm() {
    this.form = this.fb.group({
      name: null,
      gender: null,
      fee_name: null,
      paymentDate: null,
      paymentAmount: null,
      disputeDate: null,
      disputeAmount: null,
      status: null,
      respondBy: null
    });
  }

  onSearch() {
    this.filterChange.emit(this.form.value);
    this.closeSideOverlay();
  }

  closeSideOverlay(event: Event = null) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.close.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/dispute-report-search/dispute-report-search.component.ts